// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"249":"forgotPassword","884":"admin","915":"Blank","933":"auth","966":"login"}[chunkId] || chunkId) + "." + {"249":"6b1ffac2","763":"23cff400","857":"a6c7bf53","884":"ac8c4780","915":"6203e9bf","933":"ddbcf6a7","966":"94a6d59e"}[chunkId] + ".js";
};